import React from "react";

import "./SummaryPanel.scss";
import WarningIcon from "@material-ui/icons/Warning";

const SummaryPanel = (props: any) => {
  return (
    <div className="SummaryPanel--summary-container">
      {props.summary && (
        <div className="SummaryPanel--summary">
          <div>
            <div className="SummaryPanel--summary-title">Cost Summary</div>
            <div className="SummaryPanel--summary-row">
              <div className="SummaryPanel--summary-label SummaryPanel--currencyCode">
                {props.summary.currencyCode}
              </div>
              <div className="SummaryPanel--currencyAmount">
                {props.summary.currencyAmount}
              </div>
            </div>

            <div className="SummaryPanel--summary-row">
              <div className="SummaryPanel--summary-label">Rate</div>
              <div className="SummaryPanel--currencyRate">
                {props.summary.rate && props.summary.rate.toFixed(4)}
              </div>
            </div>

            <div className="SummaryPanel--summary-row">
              <div className="SummaryPanel--summary-label">Price</div>
              <div className="SummaryPanel--currencyPrice">
                {props.summary.price &&
                  props.summary.baseCurrencyCode +
                    " " +
                    props.summary.price.toLocaleString(navigator.language, {
                      minimumFractionDigits: 2
                    })}
              </div>
            </div>

            <div className="SummaryPanel--summary-row">
              <div className="SummaryPanel--summary-label">Fees</div>
              <div className="SummaryPanel--currencyFees">
                {props.summary.price &&
                  props.summary.baseCurrencyCode +
                    " " +
                    props.summary.fees.toLocaleString(navigator.language, {
                      minimumFractionDigits: 2
                    })}
              </div>
            </div>

            {/*<div className="SummaryPanel--summary-row SummaryPanel--summary-total">*/}
            {/*<div className="SummaryPanel--summary-label">{"Total"}</div>*/}
            {/*</div>*/}
          </div>
          {props.returns ? (
            <div className="SummaryPanel-warningContainer">
              <WarningIcon className="SummaryPanel-indicativeWarning" />
              <div>Prices and rates are indicative only.</div>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default SummaryPanel;
